module.exports = __webpack_public_path__ + "static/media/Sopapescado.670428c6.jpg";